import React, { useRef } from 'react';
import styled from 'styled-components';

import { useModal } from '../../../../Providers/ModalContext';
import Modal from '../../../../Global/Modal';
import RichText from '../../../../Global/RichText';

import CloseIcon from '../../../../../Images/icons/close-icon.png';
import ArtistBg from '../../../../../Images/background/bg_ai-artists.png';
import LogoStudio from '../../../../../Images/logos/logo-studio.png';
import PlayImg from '../../../../../Images/gallery/ai-services/play.png';

import { Ai_Title } from '../../../../../utils/EN/Modals/aiArtists';

const breakpoints = {
  mobile: '768px',
  tablet: '1024px',
  desktop: '1440px',
};

const CloseContainer = styled.div`
  padding: 10px;
  position: absolute;
  top: 30px;
  right: 30px;

  @media (max-width: ${breakpoints.mobile}) {
    top: 15px;
    right: 15px;
    width: 60px;
    height: 60px;
  }
`;

const CloseButton = styled.img`
  cursor: pointer;
  width: 64px;
  height: auto;
  transition: all 0.3s ease-out;
  transform-origin: center;

  @media (max-width: ${breakpoints.mobile}) {
    width: 40px;
  }

  &:hover {
    filter: drop-shadow(0px 0px 10px rgba(255, 255, 255, 1))
      drop-shadow(0px 0px 4px rgba(255, 255, 255, 1));
    transform: scale(1.15);
  }
`;

const ModalContent = styled.div`
  width: 100%;
  position: relative;
  padding: 25px 60px;
  display: flex;
  align-items: flex-start;

  flex-direction: column;
  gap: 4rem;
`;

const TitleContent = styled.div`
  display: flex;
  align-items: center;
  gap: 3.375rem;
  padding-right: 5%;

  p,
  h2,
  h3 {
    text-transform: uppercase;
  }
`;

const LogoContent = styled.div`
  display: block;
  max-width: 276px;
  width: 100%;
  padding: 15px;
  position: relative;

  img {
    display: block;
    width: 100%;
    cursor: pointer;
    transition: all 0.3s ease-out;

    &:hover {
      filter: drop-shadow(0px 0px 20px rgba(250, 115, 19, 1));
    }
  }

  &::after {
    content: '';
    position: absolute;
    width: 12px;
    height: 93px;
    background: #fff;

    top: 0;
    bottom: 0;

    margin: auto;
    right: -10%;
  }
`;

const AiArtistContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  @media (max-width: ${breakpoints.mobile}) {
    flex-direction: column;
  }
`;

const AiArtist = styled.div`
  max-width: 367px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1.313rem;
  padding-right: 20px;

  .mobile {
    display: none;
    text-transform: none;
    font-weight: 400;
    font-size: 0.75rem;

    @media (max-width: ${breakpoints.mobile}) {
      display: block;
    }
  }

  .desktop {
    display: block;

    @media (max-width: ${breakpoints.mobile}) {
      display: none;
    }
  }

  @media (max-width: ${breakpoints.mobile}) {
    max-width: 100%;
    padding-right: 0;
  }
`;

const AiArtistTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 1.25rem;

  @media (max-width: ${breakpoints.mobile}) {
    flex-direction: row;
  }

  p {
    text-transform: uppercase;
    text-align: center;
    padding: 10px;

    @media (max-width: ${breakpoints.mobile}) {
      font-size: 1.25rem;
    }
  }
`;

const AiArtistImg = styled.img`
  max-width: 271px;
  width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;

  @media (max-width: ${breakpoints.mobile}) {
    max-width: 172px;
  }
`;

const AiArtistGallery = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: row;
  padding: 10px 0;

  @media (max-width: ${breakpoints.mobile}) {
    flex-direction: column;
    gap: 0.75rem;
  }
`;

const AiArtistItem = styled.div`
  color: #fff;
  text-decoration: none;
  max-width: 348px;
  width: 100%;
  height: 786px;
  display: flex;
  align-items: flex-start;
  gap: 0.625rem;
  flex-direction: column;
  background: #000;
  background-image: url(${({ $bgImage = '' }) => $bgImage});
  background-size: contain;
  background-repeat: no-repeat;
  background-position: top center;
  cursor: pointer;

  @media (max-width: ${breakpoints.mobile}) {
    max-width: 100%;
    height: 165px;
    background-size: cover;
    background-position: center;
  }

  p {
    text-transform: uppercase;
    padding: 0 10px;
    color: #fff;
    text-decoration: none;
  }
`;

const AiArtistVideo = styled.img`
  width: 100%;
  height: auto;
  display: block;

  @media (max-width: ${breakpoints.mobile}) {
    width: 66px;
    margin: 0 auto;
  }
`;

const ModalAiArtist = ({
  id,
  artistImage,
  artistName,
  artistTitle,
  artisText,
  videoRef1,
  videoRef2,
  videoRef3,
  videoBg1,
  videoBg2,
  videoBg3,
  videoText1,
  videoText2,
  videoText3,
}) => {
  const { closeModal } = useModal();

  const { openModal } = useModal();

  const handleClick = (e) => {
    const target = e.currentTarget.dataset.target;
    openModal(target);
  };

  return (
    <>
      <Modal id={id} bgImg={ArtistBg}>
        <CloseContainer>
          <CloseButton
            onClick={closeModal}
            aria-label="Close modal"
            src={CloseIcon}
          />
        </CloseContainer>
        <ModalContent>
          <TitleContent>
            <LogoContent>
              <img
                src={LogoStudio}
                onClick={closeModal}
                aria-label="Close modal"
                alt="Kuter Studio"
              />
            </LogoContent>
            <RichText dataText={Ai_Title} />
          </TitleContent>

          <AiArtistContainer>
            <AiArtist>
              <AiArtistTitle>
                <AiArtistImg src={artistImage} alt={artistName} />
                <div>
                  <RichText dataText={artistTitle} />
                  <RichText className="mobile" dataText={artisText} />
                </div>
              </AiArtistTitle>
              <RichText className="desktop" dataText={artisText} />
            </AiArtist>
            <AiArtistGallery>
              <AiArtistItem
                onClick={handleClick}
                data-target={videoRef1}
                $bgImage={videoBg1}
              >
                <AiArtistVideo src={PlayImg} alt="Video 1" />
                <RichText dataText={videoText1} />
              </AiArtistItem>
              <AiArtistItem
                onClick={handleClick}
                data-target={videoRef2}
                $bgImage={videoBg2}
              >
                <AiArtistVideo src={PlayImg} alt="Video 2" />
                <RichText dataText={videoText2} />
              </AiArtistItem>
              <AiArtistItem
                onClick={handleClick}
                data-target={videoRef3}
                $bgImage={videoBg3}
              >
                <AiArtistVideo src={PlayImg} alt="Video 3" />
                <RichText dataText={videoText3} />
              </AiArtistItem>
            </AiArtistGallery>
          </AiArtistContainer>
        </ModalContent>
      </Modal>
    </>
  );
};

export default ModalAiArtist;
